import { render } from "./Tarefas.vue?vue&type=template&id=5ce73b26&scoped=true&ts=true"
import script from "./Tarefas.vue?vue&type=script&lang=ts"
export * from "./Tarefas.vue?vue&type=script&lang=ts"

import "./Tarefas.vue?vue&type=style&index=0&id=5ce73b26&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce73b26"]])

export default __exports__